import Vue from 'vue'
import masker from '@/shared/mask/masker'
import moment from 'moment'
import { formatarPercentual } from '@/shared/utils'

Vue.filter('toCnpj', value => {
    return masker(value, '##.###.###/####-##')
})

Vue.filter('toCpf', value => {
    return masker(value, '###.###.###-##')
})

Vue.filter('toCpfMasked', value => {
    if (!value) return ''
    const digits = value.toString().replace(/\D/g, '').padStart(11, '0')
    return `***.${digits.substr(3, 3)}.${digits.substr(6, 3)}-**`
})

Vue.filter('toCpfCnpj', value => {
    return masker(value, ['##.###.###/####-##', '###.###.###-##'])
})

Vue.filter('toCpfCnpjMasked', value => {
    if (!value) return ''
    const digits = value.toString().replace(/\D/g, '')
    if (digits.length === 11) {
        return `***.${digits.substr(3, 3)}.${digits.substr(6, 3)}-**`
    }
    const d = digits.padStart(14, '0')
    return `${d.substr(0, 2)}.${d.substr(2, 3)}.${d.substr(5, 3)}/${d.substr(8, 4)}-${d.substr(12)}`
})

Vue.filter('toNirf', value => {
    return masker(value, ['#.###.###-#'])
})

Vue.filter('toSicab', value => {
    return masker(value, ['AA.####.#######.##'])
})

Vue.filter('toStatus', value => {
    return `<strong>${value}</strong>`
})

Vue.filter('toTelefone', value => {
    return masker(value, ['(##) #####-####', '(##) ####-####'])
})

Vue.filter('toCep', value => {
    return masker(value, '#####-###')
})

Vue.filter('toDate', value => {
    return value ? moment(value).format('DD/MM/YYYY') : ''
})

Vue.filter('toDateTime', value => {
    return value ? moment(value).format('DD/MM/YYYY HH:mm') : ''
})

Vue.filter('tamanhoArquivoFormatado', value => {
    if (value === 0) 
        return '0 Bytes'

    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(value) / Math.log(k))
    
    return parseFloat((value / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
})

Vue.filter('moeda', function (value, decimals = 2) {
  if (typeof value !== "number") {
    value = Number(value) || 0;
  }
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
});

Vue.filter('decimal', (value, decimals = 2) => {
    if (value === null || value === undefined || value === '') return ''
    
    const num = Number(value)
    
    if (!isFinite(num)) return ''
    
    const factor = Math.pow(10, decimals)
    const truncated = Math.trunc(num * factor) / factor
    
    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(truncated)
})

Vue.filter('percentual', value => {
    return formatarPercentual(value)
})